import type { MCPType } from '@kirin/api-client/contracts/mcp';
import { platformLabels } from '@/components/shared/platform/platform-utils';

// Transport labels — re-exported from the shared contract (single source of truth).
export { transportLabels } from '@kirin/api-client/contracts/mcp';

// Source labels — re-exported from platformLabels (single source of truth).
export const sourceLabels = platformLabels;

export const typeLabels: Record<MCPType, string> = {
  local: 'Local',
  remote: 'Remote',
};
